<template>
  <div>
    <v-card outlined class="mb-4">
      <v-card-title>
        {{ $t("Settings") }}
      </v-card-title>
      <v-card-text>
        <v-switch
          flat
          :ripple="false"
          v-model="page.Enabled"
          :label="$t('Enabled')"
          light
          class="testaiko"
          hide-details="auto"
        >
        </v-switch>

        <v-switch
          flat
          :ripple="false"
          v-model="page.EnableApi"
          :label="$t('Enable API')"
          light
          class=""
          hide-details="auto"
        >
        </v-switch>

        <v-switch
          flat
          :ripple="false"
          v-model="page.Custom"
          :label="$t('Custom')"
          light
          class=""
          hide-details="auto"
        >
        </v-switch>

        <v-switch
          flat
          :ripple="false"
          v-model="page.Group"
          :label="$t('Is grouppage')"
          light
          class=""
          hide-details="auto"
        >
        </v-switch>

        <v-switch
          flat
          :ripple="false"
          v-model="page.RepeatingContent"
          :label="$t('Repeat content')"
          light
          class=""
          hide-details="auto"
        >
        </v-switch>

        <v-switch
          flat
          :ripple="false"
          v-model="page.CacheContent"
          :label="$t('Cache content')"
          light
          class=""
          hide-details="auto"
        >
        </v-switch>

        <v-switch
          flat
          :ripple="false"
          v-model="page.EnableOnSitemap"
          :label="$t('Enable on sitemap')"
          light
          class=""
          hide-details="auto"
        >
        </v-switch>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: [Array, Object],
    },
  },
};
</script>

<style>
</style>